module.exports = "https://www.gc-pro.gnp.com.mx/3c7268c94308cd01be1ba4d26f72c36f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg-video-18.jpg
// module id = 945
// module chunks = 0 1